export const initialData = {
  cep: '',
  logradouro:'',
  bairro: '',
  numero_endereco: '',
  complemento: '',
}
export default initialData;
    